import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

import { formatNull, formatDate, formatOverflow } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';
import LoadingLines from '../../LoadingLines';
import WarningPanel from '../../WarningPanel';

import IconContainer from '../../IconContainer';
import { ReactComponent as ReloadIcon } from '../../../icons/reload.svg';

const OverdueProcedures = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    const [limitForView, setLimitForView] = React.useState(50);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.get(`/api/get-overdue-procedures?limitForView=${limitForView}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then((response) => {
            setWarning('');
            setCases(response.data);
        })
        .catch((error) => {
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload]);


    return (
        <>
        <div className='tableContainer'>        
            <div className='tableHeaderWrapper'>
                <div className='tableStatus'>
                    <h3>Дела с непредставленным в срок отчётом</h3>
                    <a className='lastUpdateWrapper'>
                        {loading ? 
                            <Loading type='inline' /> 
                        : 
                            <IconContainer Icon={ReloadIcon} onClick={() => {setReload(true); setLoading(true)}} size = '14' color = 'black' className = '' />
                        }
                    </a>
                </div>
                <div className='tableHeader' style={{ gridTemplateColumns: '8fr 14fr 24fr 10fr 14fr 14fr 16fr' }}>
                    <div>Номер</div>
                    <div>Процедура / Должник</div>
                    <div>Арбитражный суд / Управляющий</div>
                    <div>Дата выбора управляющего</div>
                    <div>Дата судебного заседания об утверждении АУ</div>
                    <div>Дата утверждения управляющего АС</div>
                    <div>Начальная дата / Крайняя дата следующего отчета</div>
                </div>
            </div>
            {(cases.length==0 && loading) ? <LoadingLines /> 
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => { setReload(true); setLoading(true) }} />
            : cases.map((caseItem) => (
                <motion.div
                    key={caseItem.id}
                    className='tableRow'
                    style={{ gridTemplateColumns: '8fr 14fr 24fr 10fr 14fr 14fr 16fr' }}
                    onClick={() => navigate(`/case/${caseItem.id}`, { state: { from: location.pathname + location.search + location.hash }})}
                    initial={{ scale: '97%', opacity: 0 }}
                    animate={{ scale: '100%', opacity: 1 }}
                    exit={{ scale: '97%', opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                        <div>
                            {formatNull(caseItem.number)} 
                            {caseItem.nameCategory === 'Жалоба' && '(Жалоба)'} 
                            <span className='grayText'>
                                {caseItem.internal_number}
                            </span>
                        </div>
                        <div
                            className='CellForHorizontalLine'
                        >
                            <p
                                className='grayText'
                            >
                                {formatNull(caseItem.procedure_name)}
                            </p>
                            <span className='horizontalLine'></span>
                            <p>
                                {caseItem.debtors ?
                                    <p>
                                        {formatOverflow(caseItem.debtors.map((e) => e.name).join(', '))}
                                    </p>
                                    :
                                    formatNull(caseItem.debtors)
                                }
                            </p>
                        </div>
                        <div>
                            <p>{formatNull(caseItem.court_name)}</p>
                            <span className='horizontalLine'></span>
                            {caseItem.user_lastname ? 
                            <p>{`${caseItem.user_lastname} ${formatNull(caseItem.user_firstname)} ${formatNull(caseItem.user_surname)} ${formatNull(caseItem.user_email)}`}</p>
                            : 
                            <p className='colorCell red'>Управляющий не выбран</p>}
                        </div>
                        <div
                            // className={isRedDateSubmissionCandidate(caseItem) ? 'redCell' : ''}
                        >
                            {formatDate(caseItem.date_submission_candidate)}
                        </div>
                        <div>
                            {formatDate(caseItem.date_court)}
                        </div>
                        <div>
                            <p>{formatDate(caseItem.date_am_appointment_m)}</p>
                            <p className='description'>(полная версия)</p>
                            <p>{formatDate(caseItem.date_am_appointment_r)}</p>
                            <p className='description'>(рез. часть)</p>
                        </div>
                        <div>
                            <p>{formatDate(caseItem.date_start)}&nbsp;/&nbsp;<span className={'colorCell red'}>{formatDate(caseItem.date_next_meeting_creditors)}</span></p>
                        </div>
                </motion.div>
            ))}
            {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
                <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                    <div></div>
                    <div>
                        <button
                            type='button'
                            className='button'
                            style={{ width: 'fit-content' }}
                            onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                            disabled={loading}
                        >
                            {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                        </button>
                    </div>
                    <div></div>
                </div>
            )}
        </div>
    </>
  )
}

export default OverdueProcedures;
